import type { PaginatedApiResponse } from "./api.types";

export type AnnouncementScopeType = "system" | "role" | "user";

export enum AnnouncementStatus {
  SCHEDULED = 1,
  ACTIVE = 2,
  EXPIRED = 3,
}

export enum AnnouncementUrgency {
  WARNING = 1,
  CRITICAL = 2,
  INFO = 3,
}

export type UrgencyLevel = AnnouncementUrgency;

export type AnnouncementFormState = {
  title: string;
  message: string;
  scopeType: AnnouncementScopeType;
  roles: string[];
  userIds: string[];
  sendType: "now" | "scheduled";
  scheduledAt: string;
  inApp: boolean;
  email: boolean;
  urgencyLevel: UrgencyLevel;
  endTime: string;
};

export type AnnouncementListItem = {
  id: string;
  title: string;
  // Optional scope/channel summary; current API does not provide scope fields
  scopeType?: AnnouncementScopeType;
  scopeSummary?: string;
  channels?: string;
  urgencyLevel: UrgencyLevel;
  status: AnnouncementStatus;
  endTime?: string;
  scheduledAt?: string;
  createdAt: string;
};

// Backend API shapes used for system announcements

export type AnnouncementApiItem = {
  id?: string;
  title?: string;
  urgency?: number;
  status?: number;
  ends_at?: string;
  endsAt?: string;
  starts_at?: string;
  startsAt?: string;
  created_at?: string;
  createdAt?: string;
};

export type AnnouncementsResponseRaw = PaginatedApiResponse<unknown[]> & {
  data?: AnnouncementApiItem[];
  total?: number;
  page?: number;
  limit?: number;
  totalPages?: number;
  total_items?: number;
  current_page?: number;
  total_pages?: number;
  currentPage?: number;
  pageLimit?: number;
};

export type StatisticsPayload = {
  total_recipients?: number;
  total?: number;
  pending?: number;
  sent?: number;
  failed?: number;
  stats?: {
    total?: number;
    pending?: number;
    delivered?: number;
    failed?: number;
  };
};

export type StatisticsResponseRaw = {
  status?: boolean;
  message?: string;
  data?: StatisticsPayload;
};

export type DeliveryApiItem = {
  id?: string;
  user?: {
    id?: string;
    name?: string | null;
    email?: string | null;
    preferred_language?: string | null;
  } | null;
  name?: string | null;
  email?: string | null;
  email_sent?: boolean;
  email_sent_at?: string | null;
  email_failed?: boolean;
  notification_sent?: boolean;
  notification_sent_at?: string | null;
  notification_failed?: boolean;
};

export type DeliveriesResponseRaw = {
  status?: boolean;
  message?: string;
  data?: DeliveryApiItem[];
  total?: number;
  page?: number;
  limit?: number;
  totalPages?: number;
  totalItems?: number;
  total_items?: number;
  currentPage?: number;
  current_page?: number;
  total_pages?: number;
  pageLimit?: number;
};

export type AnnouncementDetailsApi = AnnouncementApiItem & {
  message?: string;
  message_fi?: string | null;
  message_sv?: string | null;
  message_de?: string | null;
  title_fi?: string | null;
  title_sv?: string | null;
  title_de?: string | null;
  delivery_type?: ("email" | "in-app")[];
  deliveryType?: ("email" | "in-app")[];
  target_user_roles?: string[] | null;
  targetUserRoles?: string[] | null;
  target_user_ids?: string[] | null;
  targetUserIds?: string[] | null;
  urgency?: number;
  status?: AnnouncementStatus | number;
};
